import { render, staticRenderFns } from "./h5Code.vue?vue&type=template&id=07eddf06&scoped=true&"
import script from "./h5Code.vue?vue&type=script&lang=js&"
export * from "./h5Code.vue?vue&type=script&lang=js&"
import style0 from "./h5Code.vue?vue&type=style&index=0&id=07eddf06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eddf06",
  null
  
)

export default component.exports